import { useLayoutEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import Privacy from "@/pages/Privacy";
import { Toaster } from "@/components/ui/sonner";

function ScrollManager() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const isProjectDetail = pathname.startsWith("/realisaties/");
    const previousScrollRestoration = window.history.scrollRestoration;

    if (isProjectDetail) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    return () => {
      if (isProjectDetail) {
        window.history.scrollRestoration = previousScrollRestoration;
      }
    };
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/realisaties/:slug" element={<ProjectDetail />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
